module.exports = __webpack_public_path__ + "static/media/declined-status.1a46d525.svg";